"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @abstract
 * A React Hook to help you write BEM CSS classes quickly and easily.
 * @param block - the base class.
 * @returns a class generator function: `(element?: string, modifier?: string) => 'block__element--modifier'`
 * @param element - the `__element` class. Optional. Pass '' to modify the block class.
 * @param modifier - the `--modifier` class. Optional.
 * @see BEM docs https://getbem.com/
 * @example
 * const bem = useBEMClasses('rwc-component');
 *
 * bem();
 * // 'rwc-component'
 *
 * bem('content')
 * // 'rwc-component__content'
 *
 * bem('content', 'hidden')
 * // 'rwc-component__content--hidden'
 *
 * bem('', 'alt')
 * // 'rwc-component--alt'
 */

function useBEMClasses(block) {
  return function (element, modifier) {
    return block + (element ? "__".concat(element) : '') + (modifier ? "--".concat(modifier) : '');
  };
}

exports.default = useBEMClasses;